module.exports = __webpack_public_path__ + "img/logo.f8537df2.png";